module.exports = __webpack_public_path__ + "media/Dokumentation_Elefanten.a733553b.mp3";